import './Contact.css';
import { useEffect, useState } from 'react';

function Contact({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3000);
    setFormData({ name: '', email: '', message: '' });
  };

  const contactCards = [
    { icon: "✉", label: "Email", value: "christiankalaw@gmail.com", link: "mailto:christiankalaw@gmail.com" },
    { icon: "📞", label: "Phone", value: "+63 912 345 6789", link: null },
    { icon: "📍", label: "Location", value: "Lipa City, Batangas", link: null },
  ];

  return (
    <div className="contact-page">
      {/* ── Hero Strip ── */}
      <div className="contact-hero-strip">
        <div className="contact-strip-inner">
          <p className="contact-strip-label">Get In Touch</p>
          <h1 className="contact-strip-name">Contact Me</h1>
          <p className="contact-strip-role">Let's connect! I'm always open to new opportunities and collaborations.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ Open to Messages</span>
            <span className="hero-stat-pill">▸ Replies within 24h</span>
          </div>
          <div className="hero-watermark">◇</div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="contact-main">
        {/* Status bar */}
        <div className="contact-status-bar">
          <span className="contact-status-dot"></span>
          <span>Currently available for projects & collaborations</span>
        </div>

        {/* Contact Info Cards */}
        <div className="contact-cards-row">
          {contactCards.map((c, i) => (
            <div className="contact-info-card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="contact-info-icon">{c.icon}</div>
              <span className="contact-info-label">{c.label}</span>
              {c.link ? (
                <a href={c.link} className="contact-info-value">{c.value}</a>
              ) : (
                <span className="contact-info-value">{c.value}</span>
              )}
            </div>
          ))}
        </div>

        {/* Form + Sidebar */}
        <div className="contact-grid">
          <div className="contact-form-card">
            <div className="contact-form-header">
              <h2>Send a Message</h2>
              <p>Fill out the form below and I'll get back to you soon.</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Your Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name} 
                    onChange={handleChange} 
                    className="form-input" 
                    placeholder="Juan Dela Cruz" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input 
                    type="email" 
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange} 
                    className="form-input" 
                    placeholder="juan@example.com" 
                    required 
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message" 
                  value={formData.message} 
                  onChange={handleChange} 
                  className="form-textarea" 
                  placeholder="Hello, I'd like to talk about..." 
                  required 
                />
              </div>
              <button type="submit" className={`form-submit ${sent ? 'form-submit--sent' : ''}`}>
                {sent ? '✓ Message Sent!' : 'Send Message →'}
              </button>
            </form>
          </div>

          <div className="contact-sidebar">
            <div className="contact-sidebar-card">
              <h3>Let's work together.</h3>
              <p>I'm currently open to new opportunities, collaborations, and projects. Whether you have a question or just want to say hi, feel free to reach out!</p>
            </div>
            <div className="contact-socials">
              <a href="https://github.com/christiankalaw" target="_blank" rel="noreferrer" className="contact-social-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
                GitHub
              </a>
              <a href="https://linkedin.com/in/christiankalaw" target="_blank" rel="noreferrer" className="contact-social-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="contact-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="contact-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Contact;
